import React from 'react';
import {isHD} from '../shared/preferences.js';
export default function QualityBadge({station,compact=false}){
  if(!isHD(station))return null;
  return <span aria-label={`HD, ${station.bitrate} kbps`} title={`${station.bitrate} kbps · HD`} className={`absolute z-10 flex items-center justify-center rounded-[3px] border border-mint/80 bg-transparent font-bold leading-none tracking-tight text-mint drop-shadow-[0_1px_2px_#0B1020] ${compact?'left-0.5 top-0.5 h-3.5 w-3.5 text-[6px]':'left-2 top-2 h-5 w-5 text-[8px]'}`}>HD</span>;
}
